import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { QueryService } from '../comun/services/query.service';
import { UsuarioPerfil } from '../comun/models/misdatos.model';
import { MisdatosService } from '../comun/services/misdatos.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  misdatos: UsuarioPerfil | null = null;
  busy = true;
  isScrolled = false;

  private misdatosSub?: Subscription;
  private cargaMisdatosSub?: Subscription;

  constructor(
    private query: QueryService,
    private misdatosService: MisdatosService
  ) {}

  ngOnInit(): void {
    this.onWindowScroll();

    // Mismo observable que escucha Salud: exclusivamente el usuario conectado.
    // Los componentes que cambien su perfil deben publicar con setMisDatos().
    this.misdatosSub = this.misdatosService.misdatos$.subscribe(
      (misdatos: UsuarioPerfil | null) => {
        this.misdatos = misdatos;
        if (misdatos !== null) this.busy = false;
      }
    );

    // Carga inicial: publica el resultado para todos los suscriptores.
    this.getMisDatos();
  }

  getMisDatos(): void {
    this.busy = true;
    this.cargaMisdatosSub?.unsubscribe();
    this.cargaMisdatosSub = this.query.query('misdatos', 'GET', null).subscribe({
      next: (resultado: UsuarioPerfil | null) => {
        this.misdatosService.setMisDatos(resultado || null);
        this.busy = false;
      },
      error: () => {
        this.busy = false;
        // No borrar los datos anteriores si la conexión falla.
      }
    });
  }

  ngOnDestroy(): void {
    this.misdatosSub?.unsubscribe();
    this.cargaMisdatosSub?.unsubscribe();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this.isScrolled = scrollY > 50;
  }
}
